/**
 * Factory que retorna a função `cell` da coluna de ações de despesa.
 * Recebe os callbacks de abrir os modais e retorna o renderer da célula.
 *
 * @param {Function} openPayModal    - Callback chamado ao clicar em "Registrar Pagamento"
 * @param {Function} openCancelModal - Callback chamado ao clicar em "Cancelar Despesa"
 * @returns {Function} Função cell compatível com CustomList
 */
export const createExpenseActionsCell = (openPayModal, openCancelModal) => (row) => (
    <div>
        {(row.status === 'pending' || row.status === 'partially_paid' || row.status === 'overdue') && (
            <a
                className="btn btn-success btn-sm btn-action"
                style={{ marginRight: '5px', color: '#fff' }}
                onClick={() => openPayModal(row)}
                title="Registrar Pagamento"
            >
                <i className="fas fa-check"></i>
            </a>
        )}
        {(row.status === 'pending' || row.status === 'overdue') && (
            <a
                className="btn btn-danger btn-sm btn-action"
                style={{ color: '#fff' }}
                onClick={() => openCancelModal(row)}
                title="Cancelar Despesa"
            >
                <i className="fas fa-ban"></i>
            </a>
        )}
    </div>
);
